import React from "react";
import { motion } from "framer-motion";

// Masked line-by-line reveal for editorial hero and section titles.
// Pass `text` as a string OR children lines as an array of strings.
export function MaskReveal({
  lines,
  className = "",
  as: Tag = "h1",
  stagger = 0.09,
  delay = 0,
  duration = 1.05,
  testId,
}) {
  return (
    <Tag className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration,
              delay: delay + i * stagger,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

// Scroll-triggered fade + rise.
export function Rise({ children, delay = 0, y = 24, once = true, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-10% 0px -10% 0px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

// Word-level reveal on scroll.
export function WordsRise({ text, className = "", stagger = 0.03, delay = 0 }) {
  const words = text.split(" ");
  return (
    <span className={className}>
      {words.map((w, i) => (
        <span key={i} className="mask-line" style={{ marginRight: "0.25em" }}>
          <motion.span
            initial={{ y: "110%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once: true, margin: "-15% 0px" }}
            transition={{
              duration: 0.9,
              delay: delay + i * stagger,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
